import { render, staticRenderFns } from "./PaginatedList.vue?vue&type=template&id=ab59cef0&scoped=true&"
import script from "./PaginatedList.vue?vue&type=script&lang=js&"
export * from "./PaginatedList.vue?vue&type=script&lang=js&"
import style0 from "./PaginatedList.vue?vue&type=style&index=0&id=ab59cef0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab59cef0",
  null
  
)

export default component.exports